export const GAMMA_PRIME = 'gamma-prime';
export const THEME_MODE = 'theme-mode';
